import { getHeaders } from '../../services/fetch';
import Mitt from 'mitt';
import { listenWithEmitter } from '../../services/communicator';

class MapData extends Mitt {

  constructor(endpoint, raw) {
    super();

    this.endpoint = endpoint;
    this.raw = raw;
    this.featureCollection = {
      type: 'FeatureCollection',
      features: []
    };
    this.data = [];
    this.started = false;
    this.starting = false;
  }

  /**
   * Sets up listeners for remote updates and fetch the initial data
   * @returns {Promise}
   */
  start = async () => {
    if (this.started || this.starting) {
      throw new Error('Already started');
    }

    this.starting = true;

    await this.initialiseListeners();

    // Send out initial data
    await this.onRequestFetch();

    this.starting = false;
    this.started = true;
  };

  initialiseListeners = async () => {
    // These are all the topics that may give us updates for the health map
    // We won't be using the payloads, so can mix
    this.connection = await listenWithEmitter([
      'hamachi-status-change',
      'hamachi-ip-change',
      'status-map-data',
      'health-information'
    ]);
    this.connection.on('closed', () => this.emit('closed'));

    if (this.connectionShouldCancel) {
      await this.connection.cancel();
      this.connectionShouldCancel = false;
      this.started = false;
      this.starting = false;
      return null;
    }

    this.connection.on('payload', this.onRequestFetch);
  };

  onRequestFetch = () => {
    return this.fetch()
      .then(data => this._emit('data', data))
      .catch(error => this._emit('error', error));
  };

  _emit = (...args) => {
    if (!(this.started || this.starting)) {
      return;
    }
    this.emit(...args);
  };

  fetch = async () => {
    let headers = {
      ...getHeaders()
    };

    const response = await fetch(this.endpoint, {
      method: 'GET',
      headers: headers
    });

    const result = await response.json();

    if (this.raw) {
      this.data = result
    } else if (Array.isArray(result)) {
      this.featureCollection = {
        ...this.featureCollection,
        features: result
      };
    } else if (result && result.features) {
      this.featureCollection = result;
    }

    return this.getData();
  };

  getData = () => {
    return this.raw ? this.data : this.featureCollection;
  };

  cancel = async () => {
    if (!(this.started || this.starting))  {
      throw new Error('Not started');
    }

    if (this.connection) {
      await this.connection.cancel();
      this.connection = null;

      this.started = false;
      this.starting = false;

    } else {
      // We were only starting up before we died
      this.connectionShouldCancel = true;
    }
  }

}

export default MapData;


// WEBPACK FOOTER //
// ./src/app/map/map-data.js